export const LOGO_PATH = '/images/logos/logo.svg';
export const SMALL_LOGO_PATH = '/images/logos/logo-small.png';
export const QR_PDF_HEADER_LOGO_PATH = '/images/logos/qr-pdf-header-logo.svg';
export const QR_PDF_FOOTER_LOGO_PATH = '/images/logos/qr-pdf-footer-logo.svg';
export const OPUS_LOGO_PATH = '/images/logos/opus-logo.svg';
